export { default } from './content-placeholder';
